<template>
    <div class="toast-wrapper" v-if="toastData">
        <p class="toast-inner">
            {{toastData.text}}
        </p>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'Toast',
    computed: {
        ...mapState(['toastData'])
    },
}
</script>

<style lang="less" scoped>
    .toast-wrapper{
        position: fixed;
        bottom: 1.5rem;
        left: 0;
        text-align: center;
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        z-index: 6;
        animation: fadeScale 0.5s linear both;
    }
    .toast-inner{
        display: inline-block;
        font-size: 0.4rem;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        line-height: 1.5;
        padding: 0.2rem 0.4rem;
        border-radius: 1rem;
    }

    @keyframes fadeScale{
        0%{
            opacity:0;
            transform:scale(0);
        }
        to{
            opacity:1;
            transform:scale(1);
        }
    }
</style>
